// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var logo = "NameAndLogo-module--logo--3kNWq";
export var animate = "NameAndLogo-module--animate--296hR";
export var rotate360 = "NameAndLogo-module--rotate360--2p4cL";